import React from "react";

import { useFormContext } from "react-hook-form";

import { EmailPattern } from "@common/constants";
import { FormInputField } from "@components-shared/desktop/inputs";
import { useValueAvailabilityDebounce } from "@state/hooks/shared";

export default function RegistrationEmail(props: {
	checkIsEmailAvailable: (data: string) => Promise<boolean>;
	labelClassName?: string;
}) {
	const { checkIsEmailAvailable, labelClassName } = props;
	const {
		formState: { errors },
		clearErrors,
	} = useFormContext();

	const debouncer = useValueAvailabilityDebounce();

	return (
		<FormInputField
			id="enterEmail"
			className="form__field"
			name="email"
			popoverMsg={"registration:EMAIL_DESCRIPTION"}
			label="registration:EMAIL_LABEL"
			labelClassName={labelClassName}
			placeholder="registration:EMAIL_PLACEHOLDER"
			maxLength={100}
			pattern={{
				value: EmailPattern,
				message: "registration:INVALID_EMAIL",
			}}
			validate={{
				isAvailable: async (value: string) => {
					if (errors?.["email"]) {
						clearErrors("email");
					}
					const isAvailable = await debouncer(
						value,
						checkIsEmailAvailable
					);

					return isAvailable || "registration:EMAIL_EXISTS";
				},
			}}
			required
		/>
	);
}
